import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './SearchButton.less'

interface SearchButtonProps {
  onSearch: () => void
  tooltipText?: string
  className?: string
  iconColor?: string
}

export const SearchButton: React.FC<SearchButtonProps> = ({
  onSearch,
  tooltipText = 'Search',
  className = '',
  iconColor
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onSearch()
  }

  return (
    <div className={`search-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="search-button"
        style={iconColor ? {color: iconColor} : undefined}
        onMouseDown={handleClick}
        aria-label="Search"
        title={tooltipText}
      >
        <Icon
          name={IconName.Search}
          className="search-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
